import { render, staticRenderFns } from "./CheckPage.vue?vue&type=template&id=752541a5&scoped=true&"
import script from "./CheckPage.vue?vue&type=script&lang=ts&"
export * from "./CheckPage.vue?vue&type=script&lang=ts&"
import style0 from "./CheckPage.vue?vue&type=style&index=0&id=752541a5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752541a5",
  null
  
)

export default component.exports